/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pictureRightAside.vue?vue&type=template&id=04d4b633&scoped=true&"
import script from "./pictureRightAside.vue?vue&type=script&lang=js&"
export * from "./pictureRightAside.vue?vue&type=script&lang=js&"
import style0 from "./pictureRightAside.vue?vue&type=style&index=0&id=04d4b633&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4b633",
  null
  
)

export default component.exports